export default{sources:{avif:"__VITE_ASSET__Ce0ZBPTT__ 400w",webp:"__VITE_ASSET__BIHluL2q__ 400w"},img:{src:"__VITE_ASSET__ClwHQmG4__",w:400,h:501}};